import { Container, Flex, Text, Heading, Box } from '@radix-ui/themes';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/get-variant-value';
import { Image } from '@trashlab/sitesapp/src/organizations/denversiteworks/components/shared/image';
import {
  convertYouTubeToEmbed,
  isVideoUrl,
} from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/youtube-url';

export const VideoGuide = () => {
  const rentalMediaTitle = useVariantValue(
    'RENTAL_MEDIA_TITLE',
    `Dumpster Rental Guide`,
  );
  const rentalMediaSubtitle = useVariantValue(
    'RENTAL_MEDIA_SUBTITLE',
    `Watch this video to guide you on renting a dumpster`,
  );
  const rentalMediaUrl = useVariantValue(
    'RENTAL_MEDIA_URL',
    '/default/rental-media.svg',
  );

  // Detect if the URL is a video (YouTube, Vimeo, etc.) or an image
  const isVideo = isVideoUrl(rentalMediaUrl);
  const isImage = !isVideo;

  // Convert YouTube watch URLs to embed format for iframe compatibility
  const embedUrl = isVideo
    ? convertYouTubeToEmbed(rentalMediaUrl)
    : rentalMediaUrl;

  return (
    <Container
      size="4"
      p="8"
      className={`relative min-h-[200px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[url('/default/rental-steps-bg.svg')] before:bg-cover before:bg-center before:bg-no-repeat before:opacity-100 before:-z-10 after:content-[''] after:absolute after:inset-0 after:opacity-90 after:-z-10`}
    >
      <Flex direction="column" gap="2" className="order-1 md:order-2">
        <Text
          size="2"
          weight="bold"
          className="text-neutral-400"
          data-variable="RENTAL_MEDIA_TITLE"
        >
          {rentalMediaTitle}
        </Text>

        <Heading as="h2" size="8" data-variable="RENTAL_MEDIA_SUBTITLE">
          {rentalMediaSubtitle}
        </Heading>

        <Box style={{ marginTop: '20px' }}>
          {isImage && (
            <Image
              src={rentalMediaUrl}
              alt="Dumpster rental guide image"
              className="rounded-xl w-full shadow-[0px_7px_26px_rgba(0,0,0,0.08)]"
              style={{ height: '500px', objectFit: 'cover' }}
              data-variable="RENTAL_MEDIA_URL"
            />
          )}
          {isVideo && (
            <iframe
              height="500"
              src={embedUrl}
              title="Dumpster rental guide video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="rounded-xl w-full shadow-[0px_7px_26px_rgba(0,0,0,0.08)]"
              data-variable="RENTAL_MEDIA_URL"
            />
          )}
        </Box>
      </Flex>
    </Container>
  );
};

export default VideoGuide;
